var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#053b5c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tl_category_accountability_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.92,25.15V16a3.5,3.5,0,0,0-3.49-3.49H19A3.5,3.5,0,0,0,15.52,16V84A3.5,3.5,0,0,0,19,87.5H77.43A3.49,3.49,0,0,0,80.92,84V74.85H41.2a5.87,5.87,0,0,1-6.06-5.66V30.81a5.87,5.87,0,0,1,6.06-5.66ZM41.2,29.51H83.07a1.36,1.36,0,0,1,1.41,1.3V69.19a1.36,1.36,0,0,1-1.41,1.3H41.2a1.35,1.35,0,0,1-1.4-1.3V30.81a1.35,1.35,0,0,1,1.4-1.3M53.89,57c1.92,0,3.49-3.32,3.49-7.42s-1.57-7.41-3.49-7.41-3.49,3.32-3.49,7.41S52,57,53.89,57"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountability);
export default __webpack_public_path__ + "static/media/accountability.107f7c2fd0c0af6317fca83014f6011d.svg";
export { ForwardRef as ReactComponent };